import { render, staticRenderFns } from "./AzurePreviewImage.vue?vue&type=template&id=0ccbd7cf&scoped=true"
import script from "./AzurePreviewImage.vue?vue&type=script&lang=js"
export * from "./AzurePreviewImage.vue?vue&type=script&lang=js"
import style0 from "./AzurePreviewImage.vue?vue&type=style&index=0&id=0ccbd7cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbd7cf",
  null
  
)

export default component.exports